import {
  AHIcon,
  AHIconType,
  AHText,
  Box,
  ColorType,
  IconSize,
  TouchableBox,
  useIconSize,
  useTheme,
} from "arkh";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useIsConstrainedHeight } from "../common/Utils/useIsContrainedHeight";

import { ModalTabletAwareKeyboardStickyView } from "./mobile/ModalTabletAwareKeyboardStickyView";
import { ActivityIndicator } from "react-native";

export function ActionFooter(props: {
  primary?: React.ReactNode;
  secondary?: React.ReactNode;
  safeInsetBottom?: boolean;
}) {
  const insets = useSafeAreaInsets();
  const isCompact = useIsConstrainedHeight();
  return (
    <ModalTabletAwareKeyboardStickyView
      offset={{
        closed: -insets.bottom,
      }}
    >
      <Box
        color="surface"
        spaceVertical={isCompact ? "small" : "medium"}
        spaceHorizontal="medium"
        borderColor="border-primary"
        insets={{
          bottom: insets.bottom,
        }}
        style={[
          {
            borderTopWidth: 1,
            marginBottom: -insets.bottom,
            flexDirection: "row-reverse",
            alignItems: "center",
            justifyContent: "space-between",
          },
        ]}
      >
        {props.primary}
        {props.secondary}
      </Box>
    </ModalTabletAwareKeyboardStickyView>
  );
}

function ActionFooterPrimary(props: {
  title?: React.ReactNode;
  icon: AHIconType;
  loading?: boolean;
  onPress: () => void;
}) {
  return (
    <TouchableBox
      spaceHorizontal="medium"
      spaceVertical="small"
      color="primary"
      cornerRadius="large"
      disabled={props.loading}
      onPress={() => {
        props.onPress();
      }}
      style={[
        {
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        },
      ]}
    >
      <AHText
        numberOfLines={1}
        type="subtitle"
        color="text-inverted"
        spaceRight="small"
      >
        {props.title}
      </AHText>

      {props.loading ? (
        <IconLoading icon={props.icon} color="text-inverted" />
      ) : (
        <AHIcon type={props.icon} size="small" color="text-inverted" />
      )}
    </TouchableBox>
  );
}

function IconLoading(props: {
  icon: AHIconType;
  loading?: boolean;
  color: ColorType;
  size?: IconSize;
}) {
  const color = useTheme()[props.color];
  const size = useIconSize(props.size ?? "small");
  return (
    <ActivityIndicator
      size={"small"}
      color={color}
      style={{
        height: size,
        width: size,
      }}
    />
  );
}

function ActionFooterSecondary(props: {
  title?: React.ReactNode;
  icon: AHIconType;
  onPress: () => void;
}) {
  return (
    <TouchableBox
      spaceHorizontal="medium"
      spaceVertical="small"
      cornerRadius="large"
      onPress={() => {
        props.onPress();
      }}
      style={[
        {
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
        },
      ]}
    >
      <AHText
        numberOfLines={1}
        type="subtitle"
        color="text-primary"
        spaceRight="small"
      >
        {props.title}
      </AHText>
      <AHIcon type={props.icon} size="small" color="text-primary" />
    </TouchableBox>
  );
}

ActionFooter.Primary = ActionFooterPrimary;
ActionFooter.Secondary = ActionFooterSecondary;
